<template>
<div class="container mar-t-70 mb20 resp70">
  <div class="flexrow_green mb50" >
    <div class="subheader_flex">
      <h1 class="nomargin redhigh">Edit Store</h1>
    </div>
    <div class="flexcircle">
      <router-link :to="{name: 'member_info', params: {id: this.$route.params.eid}}"  class="btn btn-vermilion">Back</router-link>
    </div>
  </div>
  <div class="row">
    <div class="container ">
      <div class="col-lg-8 offset-lg-2  bg-white bx-shaw pad40">

          <ValidationObserver  ref="observer" v-slot="{ invalid }"  @submit.prevent="submitpage()">
        <form class="mar-t-30" >
            <h3>Site Information:</h3>
          <div class="form-group">
              <span class="loginerror">{{errorreport}}</span>
          </div>
          <div class="form-group">
            <ValidationProvider rules="required" name="Store Name" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Store Name" v-model = "member.store_name" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <ValidationProvider rules="required" name="Domain Name" v-slot="{ errors }">
          <input type="text" class="form-control" placeholder="Domain Name" v-model = "member.url" >
          <span class="loginerror">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
        <div class="form-group">
          <h6>Store Description</h6>
          <!-- <ValidationProvider rules="required" name="Name" v-slot="{ errors }"> -->
          <!-- <input type="text" class="form-control" placeholder="Store Address" v-model = "member.store_address" > -->
          <ckeditor :editor="editor"  placeholder="Store Address" v-model="member.store_desc"   name="content" data-vv-as="Content"></ckeditor>
          <!-- <span class="loginerror">{{ errors[0] }}</span>
        </ValidationProvider> -->
      </div>
      <div class="form-group">
        <!-- <ValidationProvider rules="required" name="Email" v-slot="{ errors }"> -->
        <input type="email" class="form-control"  placeholder="Site Email" v-model = "member.store_email" >
        <!-- <span class="loginerror">{{ errors[0] }}</span> -->
      <!-- </ValidationProvider> -->
      </div>
      <div class="form-group">
        <ValidationProvider :rules="{regex: /^[6-9]\d{9}$/}" name="Store Phone Number" v-slot="{ errors }">
        <input type="text" class="form-control" placeholder="Site Phone Number" v-model="member.store_phone" >
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
      <div class="form-group">
        <ValidationProvider rules="required" name="Store Pincode" v-slot="{ errors }">
        <input type="text" class="form-control"  placeholder="Store Pincode" v-model = "member.store_pincode" >
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
            <div class="form-group">
                <div class="subheader_flex">
            <h6>Shipping Type </h6>
          </div>
          <ValidationProvider rules="required" name="Shipping Type" v-slot="{ errors }">
        <input type="radio" id="shiplite" name="Ship Lite" value="Shiplite" v-model = "member.shippingtype">
        <label for="shiplite">Ship Lite</label>
        <input type="radio" id="shiprocket" name="Ship Rocket" value="shiprocket" v-model = "member.shippingtype">
        <label for="shiprocket">Ship Rocket</label>
        <input type="radio" id="pickrr" name="Pickrr" value="pickrr" v-model = "member.shippingtype">
        <label for="pickrr">Pickrr</label>
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
                <div class="form-group" v-if="member.shippingtype && member.shippingtype !== 'pickrr'">
            <ValidationProvider rules="required" name="Access Key Id" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Access Key Id" v-model = "member.shipaccessid" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
          <div class="form-group" v-if="member.shippingtype  ">
            <ValidationProvider rules="required" name="Access Key" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Access Key" v-model = "member.shipaccesskey" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      <div class="form-group">
          <div class="subheader_flex">
            <h6>Payment Option </h6>
          </div>
          <ValidationProvider rules="required" name="Payment Option" v-slot="{ errors }">
        <input type="radio" id="razorpay" name="Razorpay" value="razorpay" v-model = "member.payoption">
        <label for="razorpay">Razorpay</label>
        <input type="radio" id="paytm" name="Paytm" value="paytm" v-model = "member.payoption">
        <label for="paytm">Paytm</label>
        <input type="radio" id="payumoney" name="Pay U Money" value="payumoney" v-model = "member.payoption">
        <label for="payumoney">Pay U Money</label>
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
          <div class="form-group" v-if="member.payoption">
            <ValidationProvider rules="required" name="Access Key Id" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Access Key Id" v-model = "member.accessid" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
          <div class="form-group" v-if="member.payoption">
            <ValidationProvider rules="required" name="Access Key" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Access Key" v-model = "member.accesskey" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
              <div class="form-group">
          <div class="subheader_flex">
            <h6>Purchase Option</h6>
          </div>
          <ValidationProvider rules="required" name="Purchase Option" v-slot="{ errors }">
        <input type="radio" id="subscription" name="Purchase" value="subscription" v-model = "member.purchasetype">
        <label for="subscription">Subscription</label>
        <input type="radio" id="transaction" name="Transaction" value="transaction" v-model = "member.purchasetype">
        <label for="transaction">Transaction</label>
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
                <div class="form-group" v-if="member.purchasetype === 'subscription'">
            <ValidationProvider name="Subscription Value" v-slot="{ errors }">
            <input type="text" class="form-control" name="Subscription Value" placeholder="" value="75000" readonly  >
            <!-- <span class="loginerror">{{ errors[0] }}</span> -->
          </ValidationProvider>
        </div>
        <div class="form-group" v-if="member.purchasetype === 'transaction'">
            <!-- <ValidationProvider rules="required" name="Transaction value" v-slot="{ errors }"> -->
            <input type="text" class="form-control" placeholder="1lac - 2.5lac" value="1lac - 2.5lac"  v-model="member.transactional"  >
            <!-- <span class="loginerror">{{ errors[0] }}</span> -->
          </ValidationProvider>
        </div>
        <div class="form-group" v-if="member.purchasetype === 'transaction'">
            <!-- <ValidationProvider rules="required" name="Transaction value" v-slot="{ errors }"> -->
            <input type="text" class="form-control" placeholder="above 2.5lac" value="above 2.5lac"  v-model="member.transaction1"  >
            <!-- <span class="loginerror">{{ errors[0] }}</span> -->
          </ValidationProvider>
        </div>
      <div class="col-12 mb20">
        <div class="flexrow ">
          <div class="subheader_flex">
            <h2>Store Logo </h2>
          </div>
        </div>
        <div class="onebox mb10 ">
          <label class="profile1">
            <input v-if="member.store_logo != ''" type='file' @change="uploadChange($event)" />
            <img class="asp_imgp" v-if="postImageUrl != ''" :src="postImageUrl" width="100%" height="100%">
            <img v-if="member.store_logo == null && postImageUrl == ''"  src="@/assets/images/logodefault.png" class="asp_imgp"   style="width:100%;height:100%" alt="">
            <img class="asp_imgp img-fluid"  v-if="member.store_logo != null && postImageUrl == ''" :src="`${$imageUrl}` +member.store_logo"  style="margin-bottom:10px; width:100%; height:100%" alt="">
          </label>
      </div>
      </div>
    <div class="text-center mb0">
      <button :disabled="isdisabled" type="submit" class="submit-button">Submit</button>

    </div>
        </form>
          </ValidationObserver>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  name: 'editmember',
  data () {
    return {
      isdisabled: false,
      admininfo: {
      },
      storeinfo: {},
      member: {
      },
      editor: ClassicEditor,
      files: [],
      error: false,
      errorreport: '',
      postImageUrl: ''
    }
  },
  mounted () {
    this.getadmininfo()
    this.storeinfoo()
  },
  methods: {
    getadmininfo () {
      this.$http.get('/register/getadmininfo/' + this.$route.params.eid).then((response) => {
        if (response.data.success === true) {
          this.admininfo = response.data.details[0]
        }
      })
    },
    storeinfoo () {
      this.$http.get('/register/getstoreinfo/' + this.$route.params.eid).then((response) => {
        if (response.data.success === true) {
          this.storeinfo = response.data.details[0]
        var output = {};
        output = this.jsonConcat(output, this.admininfo);
        output = this.jsonConcat(output, this.storeinfo);
        this.member = output
        console.log(this.member)
        }
      })
    },
     jsonConcat(o1, o2) {
       console.log(o1)
       console.log(o2)
        for (var key in o2) {
        o1[key] = o2[key];
        }
        return o1;
        },

    uploadChange ($event) {
      this.convertBase64($event.target)
    },
    convertBase64 (inputValue) {

      const file = inputValue.files[0]
  console.log(file)
      this.files.push({filee: file})
      const myReader = new FileReader()
      myReader.onloadend = (e) => {
        this.postImageUrl = myReader.result
        this.ImageUrl = myReader.result
      }
      myReader.readAsDataURL(file)
    },

async submitpage () {
  this.vueloaders = true
  const isValid = await this.$refs.observer.validate()
if (isValid) {
  this.isdisabled = true
this.errorreport = ''
this.member.userid = this.admininfo.userid
  this.$http.put('/register/updateinfo/' + this.$route.params.eid, this.member).then((res) => {
    if (res.data.success === true) {
      console.log(this.member.excelpath)
      console.log(this.member.store_pincode)
      if(this.member.store_pincode !== '' && (this.member.excelpath === '' || this.member.excelpath === null)){
        console.log('test')
        this.vueloaders = true
        this.$http.post('register/saveexcel',{pincode: this.member.store_pincode, storename: this.member.store_name, reg_id: this.member.reg_id}).then((res)=> {
          if(res.data.success === true){

          }
          this.vueloaders = false
        })
      }
      let formData = new FormData()
      if (this.files.length !== 0) {
        for (let j = 0; j < this.files.length; j++) {
          let file = this.files[j].filee
          formData.append('files[' + j + ']', file)
        }
        console.log(this.files)
        console.log(formData)
        formData.append('st_id', this.storeinfo.st_id)
        this.$http.put('/register/storelogo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res1) => {
          if (res1.data.success === true) {
            this.$router.push('/member_info/' + this.$route.params.eid)
          } else {
            console.log(res.data.message)
          }
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.$router.push('/member_info/' + this.$route.params.eid)
      }

    }
    this.isdisabled = false
  }).catch((err) => {
    this.isdisabled = false
    console.log(err)
  })
} else {
  console.log('required feilds')
// this.errorreport = "All Feilds Are Required."
}
}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/edit-store.vue